(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pg-root]').forEach((root) => {
      if (root.dataset.pgInitialised) return;
      const source = root.querySelector('[data-pg-variants]');
      let variants;
      try { variants = JSON.parse(source.textContent); } catch { return; }
      if (!Array.isArray(variants) || variants.length === 0) return;
      const colour = root.querySelector('[data-pg-colour]');
      const size = root.querySelector('[data-pg-size]');
      const field = root.querySelector('[data-pg-variant]');
      if (!colour || !size || !field) return;
      root.dataset.pgInitialised = 'true';
      const purchase = root.dataset.pgPurchase !== 'false';
      const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let imageSequence = 0;
      const showImage = (src, alt = '', selectedButton = null) => {
        const image = root.querySelector('.pg-main-image');
        if (!image || !src) return;
        const sequence = ++imageSequence;
        image.removeAttribute('srcset'); image.removeAttribute('sizes');
        image.src = src; image.alt = alt;
        root.querySelectorAll('[data-pg-image]').forEach(button => {
          const match = selectedButton ? button === selectedButton : button.dataset.pgImage === src;
          button.setAttribute('aria-pressed', String(match));
        });
        const reveal = () => {
          if (sequence !== imageSequence || reducedMotion() || typeof image.animate !== 'function') return;
          image.getAnimations().forEach(animation => animation.cancel());
          image.animate([{opacity:0.45, transform:'scale(1.012)'},{opacity:1, transform:'scale(1)'}], {duration:220, easing:'ease-out'});
        };
        if (typeof image.decode === 'function') image.decode().then(reveal).catch(() => {});
        else reveal();
      };
      const update = (chosen, updateUrl = false, syncImage = false) => {
        if (!chosen) return;
        colour.value = chosen.colour; size.value = chosen.size;
        field.value = String(chosen.id);
        const price = root.querySelector('[data-pg-price]');
        if (price) price.textContent = chosen.price;
        const sku = root.querySelector('[data-pg-sku]');
        if (sku) sku.textContent = chosen.sku;
        const add = root.querySelector('[data-pg-add]');
        if (add) {
          add.disabled = !purchase || !chosen.available;
          add.textContent = chosen.available ? 'Add to cart' : 'Currently unavailable';
        }
        const supply = root.querySelector('[data-pg-supply]');
        if (supply) supply.textContent = chosen.suppliedToOrder ? 'Supplied to order; not local stock.' : 'Availability follows the selected configuration.';
        if (syncImage && chosen.image) showImage(chosen.image, chosen.imageAlt || root.dataset.pgProduct);
        const quote = new URL(root.dataset.pgQuote, document.baseURI);
        quote.searchParams.set('product', root.dataset.pgProduct);
        quote.searchParams.set('sku', chosen.sku);
        quote.searchParams.set('variant', chosen.title);
        quote.searchParams.set('page', window.location.href);
        root.querySelectorAll('[data-pg-quote-link]').forEach(a => a.href = quote.href);
        const wa = new URL('https://wa.me/8615951241570');
        wa.searchParams.set('text', `Hello FARM GUARD, I would like a quotation. | Product: ${root.dataset.pgProduct} | Specification: ${chosen.title} | SKU: ${chosen.sku} | Quantity: | Destination: | Page: ${window.location.href}`);
        const waLink = root.querySelector('[data-pg-whatsapp]');
        if (waLink) waLink.href = wa.href;
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(chosen.id));
          window.history.replaceState({}, '', url.href);
        }
      };
      [colour, size].forEach(control => control.addEventListener('change', () => {
        update(variants.find(v => v.colour === colour.value && v.size === size.value), true, true);
      }));
      root.querySelectorAll('[data-pg-select-id]').forEach(a => a.addEventListener('click', event => {
        const variant = variants.find(v => String(v.id) === a.dataset.pgSelectId);
        if (!variant) return;
        event.preventDefault(); update(variant, true, true);
        root.querySelector('.pg-purchase').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        colour.focus({ preventScroll: true });
      }));
      root.querySelectorAll('[data-pg-image]').forEach(button => button.addEventListener('click', () => {
        showImage(button.dataset.pgImage, button.dataset.pgAlt || '', button);
      }));
      const form = root.querySelector('.pg-form');
      if (form) form.addEventListener('submit', event => {
        const selected = variants.find(v => String(v.id) === field.value);
        if (!purchase || !selected || !selected.available) event.preventDefault();
      });
      update(variants.find(v => String(v.id) === field.value) || variants[0]);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
